import { render, staticRenderFns } from "./TableColumnCounty.vue?vue&type=template&id=7248ef10"
import script from "./TableColumnCounty.vue?vue&type=script&lang=ts"
export * from "./TableColumnCounty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports